import { memo } from 'react'
import { Box } from '@mui/material'
import { NavLink } from 'react-router-dom'
import MuiLink from '@mui/material/Link'

import { HOME_URL } from '../../constants/navigation'

const LogoContainer = ({ src, to, sx }) => {
  return (
    <Box sx={{ ...sx }}>
      <MuiLink component={NavLink} to={to || HOME_URL}>
        <Box
          component='img'
          src={src}
          alt='Logo'
          sx={{ width: 42, height: 'auto', ...sx }}
        />
      </MuiLink>
    </Box>
  )
}

export default memo(LogoContainer)
